__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-secure-file-express-portal'].baseUrl;
import ModuleContainer from './components/AxpSecureFileExpressPortal';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "6.x"
  });
}